__turbopack_context__.v({
  "card": "_0_bt6a_card",
  "container": "_0_bt6a_container",
  "desktopButton": "_0_bt6a_desktopButton",
  "downloadButton": "_0_bt6a_downloadButton",
  "grid": "_0_bt6a_grid",
  "image": "_0_bt6a_image",
  "leftColumn": "_0_bt6a_leftColumn",
  "mobileButton": "_0_bt6a_mobileButton",
  "overlay": "_0_bt6a_overlay",
  "subtitle": "_0_bt6a_subtitle",
  "textWrapper": "_0_bt6a_textWrapper",
  "wrapper": "_0_bt6a_wrapper",
});
